import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { setCollectionTagsService } from 'src/api/collection'
import { setCollectionTagsSuccess } from 'src/reducers/collection/action'
import { SET_COLLECTION_TAGS } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

function* setCollectionTagsFlow(payload) {
  try {
    const { collectionId, tagIds, resolvedTags, callback } = payload
    yield call(setCollectionTagsService, collectionId, tagIds)
    yield put(setCollectionTagsSuccess(collectionId, resolvedTags))
    yield put(operationSuccess())
    if (callback) callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* setCollectionTagsWatcher() {
  while (true) {
    const action = yield takeMaybe(SET_COLLECTION_TAGS)
    const { payload } = action

    yield fork(generalSaga, setCollectionTagsFlow, payload, false)
  }
}
